module.exports = __webpack_public_path__ + "static/img/logo.91293219.png";